import { any, bind } from 'underscore';

function onAfterFindAll({ i18n, router }, data = {}) {
  if (data.status === 400 &&
    any(data.errors, error => error.Code === 'AdIdInvalid')) {
    window.App.views.alertCenter.toastWarning(i18n.getString('RSA_Invalid_Ad'));

    // fall back to ads page on ad group level
    router.navigateToRoute('adgroup_ad', {
      campaign_id: '$current',
      adgroup_id: '$current',
    });
  } else if (any(data.errors, err => err.Code === 'TooMuchDataToDownload')) {
    this.showTooMuchDataError = true;
  }
  return data;
}

export function setUpErrorHandling({
  gridView,
  dataSource,
  i18n,
}) {
  const view = gridView;
  view.showTooMuchDataError = false;
  view.tooMuchDataErrorText = i18n.getString('Grid_Experiment_TooMuchDataError_CmpLvl');

  // eslint-disable-next-line no-param-reassign
  dataSource.options.afterFindAll = bind(onAfterFindAll, view);
}

